import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

// TODO: delete this? not sure what it does (copied from the corresponding one in the PSD) and not sure if needed

const getDerivedFromMeasurementsConfigForPortionMassMeasurement = (prefix: string) => ({
  [`${prefix}.WetMass`]: wrap([`${prefix}.TareMass`, `${prefix}.TareAndWetMass`]),
  [`${prefix}.DryMass`]: wrap([`${prefix}.TareMass`, `${prefix}.TareAndDryMass`]),
});

export { getDerivedFromMeasurementsConfigForPortionMassMeasurement };
